/* Two-tone section headings in the brand (logo) colors:
   navy base (#00246c) + the LAST WORD in orange (#fc5400),
   mirroring the arihantbooks.com heading style but with India Book Mart's colors. */
(function () {
  var NAVY = '#00246c', ORANGE = '#fc5400';

  // Inject styles once
  var css =
    '.ibm-heading-2tone{color:' + NAVY + ' !important;}' +
    '.ibm-heading-2tone .ibm-accent-word{color:' + ORANGE + ' !important;}';
  var st = document.createElement('style');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);

  // Section-title selectors to decorate (homepage + custom sections)
  var SELECTORS = [
    '.title.h2',
    '.trust-bar__title',
    '.testimonials__title',
    '.blog-news__title',
    '.featured-strip__panel-title',
    '.video-carousel__title'
  ];

  function accentLastWord(el) {
    // Find the last text node that has visible characters
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var last = null, n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.trim()) last = n;
    }
    if (!last) return false;
    var text = last.nodeValue;
    var m = text.match(/(\S+)(\s*)$/); // last word + any trailing space
    if (!m) return false;
    var word = m[1];
    if (word.length < 1) return false;
    var before = text.slice(0, text.length - m[0].length);

    var span = document.createElement('span');
    span.className = 'ibm-accent-word';
    span.textContent = word;

    var frag = document.createDocumentFragment();
    if (before) frag.appendChild(document.createTextNode(before));
    frag.appendChild(span);
    if (m[2]) frag.appendChild(document.createTextNode(m[2]));
    last.parentNode.replaceChild(frag, last);
    return true;
  }

  function run() {
    var heads = document.querySelectorAll(SELECTORS.join(','));
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (h.getAttribute('data-ibm-accent')) continue;      // already done
      if (h.closest('footer')) continue;                    // skip footer headings
      if (!(h.textContent || '').trim()) continue;          // skip empty
      if (accentLastWord(h)) {
        h.classList.add('ibm-heading-2tone');
        h.setAttribute('data-ibm-accent', '1');
      }
    }
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
